export default __webpack_public_path__ + "static/media/TR.4f69e0a6.svg";